// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsMoveToArchiveDesktopRequest,
  TChatsMoveToArchiveDesktopModel,
  IMappers,
  TChatsMoveToArchiveDesktopResponse,
  TChatsMoveToArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsMoveToArchiveDesktopModel(
  parameters: TChatsMoveToArchiveDesktopRequest,
): TChatsMoveToArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/move-to-archive-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsMoveToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsMoveToArchiveDesktopRequest;
}

export async function fetchChatsMoveToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsMoveToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsMoveToArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsMoveToArchiveDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsMoveToArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsMoveToArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsMoveToArchiveDesktopResponse>;
}
